import React from 'react'
import connect from 'libraries/front-end-core/decorators/connect'
import { requestFolders } from 'services/LegislationService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import LegislationFoldersMenu from './Main'
import { requestUserFavourites } from 'services/FavouritesService'

const ConnectedLegislationFoldersMenu = connect((props) => ({
  folders: requestFolders(),
  favourites: requestUserFavourites('legislation')
}))((props) => (
  <ResponseConsumer
    responses={[props.folders, props.favourites]}
    skeleton='tiled-menu'
    content={() => <LegislationFoldersMenu {...props} />}
  />
))

export default ConnectedLegislationFoldersMenu
